// InvoiceSidebar.js - Removed controlId from Form.Group when using htmlFor
import React from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import { CURRENCY_OPTIONS } from '../constants/currencies';
import { FaPrint } from 'react-icons/fa';
import { useGlobalContext } from '../hooks/useGlobalContext';
import { useTranslation } from 'react-i18next';

const InvoiceSidebar = ({
  invoiceState,
  subTotal,
  taxAmount,
  discountAmount,
  total,
  isPrinting,
  isFormValid,
  handlePrint
}) => {
  const { theme } = useGlobalContext(); 
  const { t } = useTranslation(); 

  return (
    <div className="sticky-top pt-md-3 pt-xl-4">
      <Button
        variant="success"
        className="d-block w-100 mt-2 mb-3"
        onClick={handlePrint}
        disabled={isPrinting || !isFormValid}
        title={t('printTooltip')}
      >
        <FaPrint style={{ marginRight: '8px' }} />
        {isPrinting ? t('generatingPdf') : t('printInvoice')} 
      </Button>
      
      <div className="mb-3">
        <Form.Label className="fw-bold" htmlFor="currency">{t('currencyLabel')}</Form.Label>
        <Form.Select
          onChange={(event) => invoiceState.onCurrencyChange({ currency: event.target.value })}
          className={`btn my-1 ${theme === 'dark' ? 'btn-dark' : 'btn-light'}`}
          aria-label="Change Currency"
        >
          {CURRENCY_OPTIONS.map((option) => (
            <option key={option.label} value={option.value}>
              {option.label}
            </option>
          ))}
        </Form.Select>
      </div>
      
      <div className="my-3">
        <Form.Label className="fw-bold" htmlFor="tax-rate">{t('taxRateLabel')}</Form.Label>
        <InputGroup className="my-1 flex-nowrap">
          <Form.Control
            name="taxRate"
            type="number"
            value={invoiceState.taxRate}
            onChange={invoiceState.editField}
            className="border"
            placeholder="0.0"
            min="0.00"
            step="0.01"
            max="100.00"
          />
          <InputGroup.Text
            className={`fw-bold text-secondary small ${theme === 'dark' ? 'bg-dark text-light' : 'bg-light'}`}
          >
            %
          </InputGroup.Text>
        </InputGroup>
      </div>
      
      <div className="my-3">
        <Form.Label className="fw-bold" htmlFor="discount-rate">{t('discountRateLabel')}</Form.Label>
        <InputGroup className="my-1 flex-nowrap">
          <Form.Control
            name="discountRate"
            type="number"
            value={invoiceState.discountRate}
            onChange={invoiceState.editField}
            className="border"
            placeholder="0.0"
            min="0.00"
            step="0.01"
            max="100.00"
          />
          <InputGroup.Text
            className={`fw-bold text-secondary small ${theme === 'dark' ? 'bg-dark text-light' : 'bg-light'}`}
          >
            %
          </InputGroup.Text>
        </InputGroup>
      </div>
    </div>
  );
};

export default InvoiceSidebar;